import React, { useContext } from 'react';
import context from '../../context';
import styled from 'styled-components';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { Container } from 'react-bootstrap';

const Wrap = styled.section`
  position: relative;
  color: #fff;
  background-image:
    linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)),
    url("${p => p.bg || ''}");
  background-size: cover;
  background-position: center 27%; /* ✅ sube la imagen */
  background-repeat: no-repeat;
  min-height: clamp(420px, 100vh, 760px);
  display: flex;
  align-items: center;

  &:before{
    content:'';
    position:absolute;
    left: 48px;
    top: 48px;
    bottom: 48px;
    width: 2px;
    background: rgba(255,255,255,.18);
    pointer-events:none;
  }
  @media (max-width: 575px){
    &:before{ left: 20px; top: 24px; bottom: 24px; }
  }
`;

const Content = styled.div`
  max-width: 780px;
  padding: 24px 0;
  margin-left: 72px;

  @media (max-width: 991px){
    margin-left: 32px;
  }
  @media (max-width: 575px){
    margin-left: 0;
  }
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  z-index: 1000;

  width: 64px;
  height: 64px;
  background-color: #fff;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  padding: 10px;

  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    display:block;
  }

  @media (max-width: 575px){
    width: 56px;
    height: 56px;
    padding: 8px;
  }
`;

const Overline = styled.div`
  display:flex;
  align-items:center;
  gap:.6rem;
  font-size:.95rem;
  letter-spacing:.12em;
  font-weight:700;
  color: rgba(255,255,255,.9);
  margin: 8px 0 14px;

  &:before{
    content:'';
    display:inline-block;
    width:12px; height:12px;
    border-left: 6px solid ${p => p.theme.primaryColor};
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 0;
  }
`;

const H1 = styled.h2`
  font-size: clamp(2.2rem, 5vw, 5rem);
  line-height: 1.05;
  font-weight: 800;
  margin: 0 0 18px;
  letter-spacing: .01em;
`;

const Lead = styled.p`
  font-size: clamp(1.05rem, 1.3vw, 1.35rem);
  line-height: 1.6;
  margin: 0 0 26px;
  max-width: 56ch;
  color: rgba(255,255,255,.92);
`;

const CTA = styled(AniLink)`
  display:inline-flex;
  align-items:center;
  gap:16px;
  text-decoration:none;
  font-weight:800;
  color:#fff;

  .square{
    width:64px; height:64px;
    background:#F9A200;
    display:grid; place-items:center;
    border-radius:4px;
  }
  .arrow{
    width: 0; height: 0;
    border-left: 16px solid #111;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .label{
    font-size:1.05rem;
    letter-spacing:.06em;
  }

  &:hover .square{
    filter:brightness(.95);
  }
`;

export default function AboutBanner() {
  const state = useContext(context);
  const data = state?.home?.about?.banner || {};

  return (
    <Wrap bg={data.image}>
      <Container>
        <Content>

          {/* Logo arriba, por encima del fondo */}
          {state?.brand?.logo && (
            <Brand>
              <img src={state.brand.logoDark} alt="Logo" />
            </Brand>
          )}

          <Overline>NOSOTROS</Overline>
          <H1>{data.title}</H1>
          <Lead>{data.subTitle}</Lead>

          <CTA paintDrip hex={state.primaryColor} to="/about" duration={.5}>
            <span className="square"><span className="arrow" /></span>
            <span className="label">{data.buttonText || 'LEER MÁS'}</span>
          </CTA>
        </Content>
      </Container>
    </Wrap>
  );
}